import {locationUpdate} from 'actions';
import {Map, OrderedSet} from 'immutable';
import {client} from 'utils/algolia';
import {SEARCH_RESULTS_HITS_PER_PAGE} from '../settings';

export const SEARCH_FOR_ICON_NEW_QUERY = 'SEARCH_FOR_ICON_NEW_QUERY';
export const SEARCH_FOR_ICON_EMPTY_QUERY = 'SEARCH_FOR_ICON_EMPTY_QUERY';
export const SEARCH_FOR_ICON_RESULTS = 'SEARCH_FOR_ICON_RESULTS';

export function searchForIcon(query, index) {
  const hitsPerPage = SEARCH_RESULTS_HITS_PER_PAGE;

  return (dispatch) => {
    dispatch({
      type: SEARCH_FOR_ICON_NEW_QUERY,
      query,
    });

    dispatch(locationUpdate({
      query: {
        q: query,  // eslint-disable-line id-length
      },
    }));

    if (query.length > 0) {
      client()
        .initIndex(index)
        .search(query, {
          hitsPerPage,
          attributesToRetrieve: ['id', 'icon_set'],
          facets: ['icon_set.id'],
          highlightPreTag: '<mark>',
          highlightPostTag: '</mark>',
        })
        .then((results) => {
          const hits = results.hits;
          const iconSetHits = OrderedSet(hits.map((hit) => hit.icon_set.id));
          const facets = results.facets['icon_set.id'] || {};
          const iconHighlights = Map(hits.map((hit) => [parseInt(hit.id, 10), hit._highlightResult.name.value]));
          const iconSetCounts = Map(Object.keys(facets).map((key) => [parseInt(key, 10), facets[key]]));
          const iconHits = OrderedSet(hits.map((hit) => hit.id));

          dispatch({
            type: SEARCH_FOR_ICON_RESULTS,
            query,
            iconSetHits,
            iconSetCounts,
            iconHits,
            iconHighlights,
            count: results.nbHits,
          });
        });
    } else {
      dispatch({
        type: SEARCH_FOR_ICON_EMPTY_QUERY,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/actions/search.js